"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAtom = void 0;
const array_literal_1 = require("../expression-tree/nodes/array-literal");
const boolean_literal_1 = require("../expression-tree/nodes/boolean-literal");
const date_literal_1 = require("../expression-tree/nodes/date-literal");
const identifier_1 = require("../expression-tree/nodes/identifier");
const null_literal_1 = require("../expression-tree/nodes/null-literal");
const number_literal_1 = require("../expression-tree/nodes/number-literal");
const reg_exp_literal_1 = require("../expression-tree/nodes/reg-exp-literal");
const string_literal_1 = require("../expression-tree/nodes/string-literal");
const uuid_literal_1 = require("../expression-tree/nodes/uuid-literal");
const field_1 = require("../field");
const uuid_1 = require("../uuid");
function createAtom(value) {
    if (typeof value === 'string') {
        return new string_literal_1.StringLiteral(value);
    }
    else if (typeof value === 'number') {
        return new number_literal_1.NumberLiteral(value);
    }
    else if (typeof value === 'boolean') {
        return new boolean_literal_1.BooleanLiteral(value);
    }
    else if (value instanceof RegExp) {
        return new reg_exp_literal_1.RegExpLiteral(value);
    }
    else if (value instanceof Date) {
        return new date_literal_1.DateLiteral(value);
    }
    else if (value instanceof Array) {
        return new array_literal_1.ArrayLiteral(value.map(createAtom));
    }
    else if (value instanceof field_1.Field) {
        return new identifier_1.Identifier(value);
    }
    else if (value === null) {
        return new null_literal_1.NullLiteral();
    }
    else if (value instanceof uuid_1.Uuid) {
        return new uuid_literal_1.UuidLiteral(value);
    }
    throw new Error(`Cannot construct atom from '${value}'`);
}
exports.createAtom = createAtom;
//# sourceMappingURL=create-atom.js.map